/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description API for the Attachments endpoint
 * @section 4.1.9.2
 * @section 4.1.9.3
 */
import useQueryHook from "./useHttpEndpoint";
export interface Attachments {
  period: string;
  parentId: string;
}
const useAttachments = () =>
  useQueryHook<Attachments | FormData>("attachments");
export default useAttachments;
